export enum InputFieldType {
  TEXT = 'text',
  PASSWORD = 'password',
  TEXTAREA = 'textarea',
  NUMBER = 'number',
}
